/* eslint-disable no-unused-vars */
import featureFlagStore from "@/store/featureFlagStore";
import { TicketInstrument } from "@/store/tradeFromScratchStore";

// LQC-2493 - which instrument the ticket writes. Controlled: the selection lives on the
// widget in tradeFromScratchStore, and the rows, required set and payload builder all
// key off it. Only instruments with a working ticket are listed, so this is not the
// InstrumentTypeCode vocabulary.

export const TICKET_INSTRUMENTS: TicketInstrument[] = [
  TicketInstrument.Bond,
  TicketInstrument.Future,
  TicketInstrument.BondOption,
  TicketInstrument.Swap,
  TicketInstrument.Swaption,
];

// Not yet released: offered only while the Trade Creation legs flag is on (LQC-2955).
const FLAGGED_INSTRUMENTS: TicketInstrument[] = [TicketInstrument.Repo];

export function returnTicketInstruments(
  isTradeCreationLegsOn: boolean,
): TicketInstrument[] {
  if (!isTradeCreationLegsOn) return TICKET_INSTRUMENTS;
  return [...TICKET_INSTRUMENTS, ...FLAGGED_INSTRUMENTS];
}

interface IInstrumentSelect {
  value: TicketInstrument;
  onChange: (value: TicketInstrument) => void;
  testId: string;
  isDisabled?: boolean;
}

const InstrumentSelect = ({
  value,
  onChange,
  testId,
  isDisabled = false,
}: IInstrumentSelect) => {
  const isTradeCreationLegsOn = featureFlagStore(
    (state) => state.tradeCreationLegs,
  );
  return (
    <select
      data-testid={testId}
      id={testId}
      value={value}
      disabled={isDisabled}
      onChange={(e) => onChange(e.target.value as TicketInstrument)}
      className="h-[28px] w-[130px] rounded-md border border-gray-300 px-1 text-xs font-semibold outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200"
    >
      {returnTicketInstruments(isTradeCreationLegsOn).map((instrument) => (
        <option key={instrument} value={instrument}>
          {instrument}
        </option>
      ))}
    </select>
  );
};

export default InstrumentSelect;
